<template>
  <ul class="sidebar__benefits hidden">
    <li class="sidebar__benefits-item">
      <img alt="" class="sidebar__benefits-icon" src="/shop/images/truck-tick.svg">
      <div class="sidebar__benefits-text">{{ in18['page_benefits_delivery'] }}</div>
    </li>
    <li class="sidebar__benefits-item">
      <img alt="" class="sidebar__benefits-icon" src="/shop/images/empty-wallet-tick.svg">
      <div class="sidebar__benefits-text">{{ in18['page_benefits_payment'] }}</div>
    </li>
  </ul>

  <div class="sidebar__contact">
    <template v-if="contact_banner && contact_banner.image">
      <a v-if="contact_banner.link" :href="contact_banner.link">
        <picture>
          <source :srcset="contact_banner.image.webp" type="image/webp">
          <img :alt="contact_banner.title" :src="contact_banner.image.source" class="img">
        </picture>
      </a>
      <template v-else>
        <picture>
          <source :srcset="contact_banner.image.webp" type="image/webp">
          <img :alt="contact_banner.title" :src="contact_banner.image.source" class="img">
        </picture>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    in18:           Object,
    contact_banner: Object,
  },
};
</script>
